import { createSlice } from "@reduxjs/toolkit";
import { addAdminaccounts, fetchAdminaccountsItems } from "./AdminaccountsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const adminaccountsSlice = createSlice({
  name: "adminaccounts",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAdminaccountsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminaccountsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAdminaccountsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addAdminaccounts.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAdminaccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(addAdminaccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default adminaccountsSlice.reducer;